import { Swiper } from 'swiper';
import {Navigation, Autoplay, Pagination} from "swiper/modules";
Swiper.use([Navigation, Autoplay, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-logo-gallery="container"]',
        slider: '[js-logo-gallery="slider"]',
        prev: '[js-logo-gallery="prev"]',
        next: '[js-logo-gallery="next"]',
        pagination: '[js-logo-gallery="pagination"]',
        
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                // slidesPerView: 6,
                spaceBetween: 20,
                loop: false,
                speed: 500,
                autoplay: {
                    delay: 2500
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                breakpoints: {
                    300: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 3
                    },
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 4
                    },
                    1100: {
                        slidesPerView: 5
                    }
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}